import { render, staticRenderFns } from "./EventSection.vue?vue&type=template&id=82d00bf2&scoped=true&"
import script from "./EventSection.vue?vue&type=script&lang=js&"
export * from "./EventSection.vue?vue&type=script&lang=js&"
import style0 from "./EventSection.vue?vue&type=style&index=0&id=82d00bf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d00bf2",
  null
  
)

export default component.exports